import React from "react";

// Footer action ("Return home"): full-width secondary button.
const BottomButton = (clickEvent, text) => {
  return (
    <div style={{ marginTop: "22px" }}>
      <button type="button" className="np-btn-secondary" onClick={clickEvent}>
        {text}
      </button>
    </div>
  );
};

export default BottomButton;
